<!--
 * @Description: 
 * @Author: Zero
 * @Date: 2019-09-19 16:58:14
 * @LastEditTime: 2019-09-23 15:08:26
 * @LastEditors: Zero
 -->
<template>
  <div>
    <ShareCoupon />
  </div>
</template>
<script>
import * as Http from '@/pages/commodity/api/share'
import * as Util from '@/assets/js/Util'
import YunJi from '@/assets/js/YunJi'
import ShareCoupon from '@/pages/commodity/views/ShareCoupon/ShareCoupon'

export default {
  data() {
    return {
      switchPersonalItem: '', // 推荐商品 新旧接口开关
      sourceContentId: YunJi.getUrlParams('sourceContentId'),
    }
  },
  components: { 
    ShareCoupon, 
  },
  mounted() {
    window.thinkingReport.track('page_load', {
      page_id: '80611',
      point_id: '25843',
      source_content_id: this.sourceContentId
    })
    // this.switchPersonalItemByCoupon() // 和小勇确认 没有不取开关了
  },
  methods: {
    switchPersonalItemByCoupon() {
      Http.switchPersonalItemByCoupon().then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          this.switchPersonalItem = res.data
        }
      })
    }

  }
}
</script>
